export default {"src":"/_next/static/media/session-icon.f5b3a333.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};